import { Page } from '@/core/architecture'

import { GachaItemListTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * GachaItemList Page
 * Implemented as a practical sample.
 */
export const GachaItemList: Page = () => {
  const { state } = useViewModel()

  return <GachaItemListTemplate state={state} />
}
